// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"241":"1505f725","284":"6c676078","377":"b4cbc635","421":"c4120298","753":"9c23f63b","798":"cd641f6e","969":"80b1d52e"}[chunkId] + ".js";
};